/* import __COLOCATED_TEMPLATE__ from './theme-mode.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type MessengerSettingsThemeProvider from 'embercom/services/messenger-settings-theme-provider';

type ThemeMode = 'system' | 'dark' | 'light';

interface MessengerThemeModeSignature {
  Args: {
    activeBrand: any;
  };
}

export default class MessengerThemeMode extends Component<MessengerThemeModeSignature> {
  @service appService: any;
  @service messengerSettingsThemeProvider!: MessengerSettingsThemeProvider;
  media = window.matchMedia('(prefers-color-scheme: dark)');

  constructor(owner: $TSFixMe, args: MessengerThemeModeSignature['Args']) {
    super(owner, args);
    this.media.addEventListener('change', this.handleSystemThemeChange);
  }

  get themeModes(): ThemeMode[] {
    return ['system', 'dark', 'light'];
  }

  @action
  private handleSystemThemeChange({ matches: isDarkMode }: MediaQueryListEvent) {
    let themeMode = this.args.activeBrand.themeMode;
    if (themeMode === 'system') {
      this.messengerSettingsThemeProvider.targetThemeType = isDarkMode ? 'dark' : 'light';
    }
  }

  @action
  handleThemeModeChange(themeMode: ThemeMode) {
    this.args.activeBrand.themeMode = themeMode;
    if (themeMode !== 'system') {
      this.messengerSettingsThemeProvider.targetThemeType = themeMode;
    } else {
      this.handleSystemThemeChange({ matches: this.media.matches } as MediaQueryListEvent);
    }
  }

  willDestroy() {
    super.willDestroy();
    this.media.removeEventListener('change', this.handleSystemThemeChange);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    MessengerThemeMode: typeof MessengerThemeMode;
    'messenger-theme-mode': typeof MessengerThemeMode;
  }
}
